/**
 * @file 开发者社区入口页
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import DeveloperBanner from './components/developer-banner/DeveloperBanner';
import DeveloperPreview from './components/developer-preview/DeveloperPreview';
import DeveloperJoin from './components/developer-join/DeveloperJoin';
import DeveloperHelp from './components/developer-help/DeveloperHelp';
import DeveloperEventCalendar from './components/developer-event-calendar/EventCalendar';
import DeveloperCommunityResource from './components/developer-community-resource/CommunityResource';
import DeveloperOpenPartner from './components/developer-open-partner/OpenResourcePartner';
// import TechCommitee from './components/developer-tech-commitee/TechCommitee';
import DeveloperOpenOrganization from './components/developer-open-organization/OpenResourceOrganization';
import DeveloperOpenFoundation from './components/developer-open-foundation/OpenResourceFoundation'

import usePaddleCom from './CommunityHook';


const DeveloperCommunity: React.FC = () => {

    const {
        topCard,
        joinCommunity,
        getHelp,
        activityCalendar,
        communityResources,
        openSourcePartners,
        openSourceorganization,
        openSourcefoundation,
        // communityGovernanceCommittee
    } = usePaddleCom();
    return (
        <div className="">
            <Header />
            <div className="paddle-developer-community-wrapper">
                <DeveloperBanner />
                <DeveloperPreview list={topCard.list} />
                <DeveloperJoin
                    title={joinCommunity.title}
                    subtitle={joinCommunity.subtitle}
                    openSourceCollaborationTitle={joinCommunity.openSourceCollaborationTitle}
                    openSourceCollaborationList={joinCommunity.openSourceCollaborationList}
                    organizationSummitListTitle={joinCommunity.organizationSummitListTitle}
                    organizationSummitList={joinCommunity.organizationSummitList}
                />
                <DeveloperHelp title={getHelp.title} list={getHelp.list} />
                <DeveloperEventCalendar
                    title={activityCalendar.title}
                    linkAllLink={activityCalendar.linkAllLink}
                    list={activityCalendar.list}
                />
                <div id="communityResource"></div>
                <DeveloperCommunityResource
                    title={communityResources.title}
                    list={communityResources.list}
                    backgroundLink={communityResources.backgroundLink}
                />
                <DeveloperOpenPartner
                    title={openSourcePartners.title}
                    list={openSourcePartners.list}
                    description={openSourcePartners.description}
                    subDesc={openSourcePartners.subDesc}
                    subDescPurpose={openSourcePartners.subDescPurpose}
                    subBtn={openSourcePartners.subBtn}
                    subLink={openSourcePartners.subLink}
                />
                <DeveloperOpenOrganization  list={openSourceorganization.list} /> 
                <DeveloperOpenFoundation list={openSourcefoundation.list} /> 
                {/* <TechCommitee 
                    title={communityGovernanceCommittee.title}
                    subtitle={communityGovernanceCommittee.subtitle}
                    btn={communityGovernanceCommittee.btn}
                    backgroundLink={communityGovernanceCommittee.backgroundLink}
                    avatarList={communityGovernanceCommittee.avatarList}
                /> */}
            </div>
            <Footer />
        </div>
    );
};

export default DeveloperCommunity;